// @core/api/endpoints/context/get_tenant_context_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetTenantContextConfigResponse,
} from '../../../types/context';

const BASE_PATH = '/context';

/**
 * Get tenant context configuration
 * Returns the tenant-level Context Panel configuration including section overrides, display limits, and role-specific weights.
 */
export async function GetTenantContextConfig(
  params?: {
  },
  options?: RequestOptions
): Promise<GetTenantContextConfigResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/context/config/tenant`;
  const requestOptions = options;
  return client.get<GetTenantContextConfigResponse>(requestPath, { ...requestOptions, params });
}
